(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amanso-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const connectSmokedHeader = () => {
      const homepage = document.querySelector('.am-home');
      const header = document.querySelector('#header-component');
      if (!homepage || !header || header.hasAttribute('data-amanso-connected')) return;
      header.setAttribute('data-amanso-connected', '');

      const scrollRoot = document.querySelector('.page-wrapper');
      let frame = 0;
      const update = () => {
        frame = 0;
        const amount = Math.max(window.scrollY || 0, scrollRoot?.scrollTop || 0);
        header.toggleAttribute('data-amanso-scrolled', amount > 24);
      };
      const requestUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      scrollRoot?.addEventListener('scroll', requestUpdate, { passive: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        connectSmokedHeader();
      }, { once: true });
    } else {
      connectSmokedHeader();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
